import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
	esp: (
		`
		<p class="mb-3">
			Floroj diskutas pri la beleco en arto. 
			Oratoras la Dorno:
		</p>

		<p class="mb-3">
			- Mi tute ne povas konsenti kun la krea metodo de la Rozo. 
			Akreco – jes, certe! Penetro ĝis plej-pleja profundo – sendube! 
			Sed prezenti ĉion en la roza koloro…
		</p>
		`
	)
}

const itemName = {
	esp: 'Krea metodo'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemTranslator: translator.esp
	}
}

export default item;